import React from "react";
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import ChangePasswordHospitalModel from "./components/ChangePasswordHospitalModel";
import LockIcon from '@mui/icons-material/Lock';
import PaymentIcon from '@mui/icons-material/Payment';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { RiLogoutBoxLine } from "react-icons/ri";
import StarBorderPurple500Icon from '@mui/icons-material/StarBorderPurple500';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';


function HospitalSidebar({ location, history, user }) {
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const onClickMenu = (url) => {
    try {
      history.push(url);
      setTimeout(() => {
        setNavbarOpen(!navbarOpen);
      }, 150);
    } catch (error) {
      console.error('Error during navigation:', error);
    }
  };


  const logout = (url) => {
    window.sessionStorage.removeItem('user');
    window.localStorage.removeItem('user');
    history.push(url);
    setTimeout(() => {
      setNavbarOpen(!navbarOpen)
    }, 150);

  }

  const logoutSubmit = () => {

    confirmAlert({
      title: 'Confirm to submit?',
      message: 'Are you sure want to logout.',
      buttons: [
        {
          label: 'Yes',
          onClick: () => logout('/')
        },
        {
          label: 'No'
        }
      ]
    });
  }

  return (

    <>
      <button className={` ${navbarOpen === true ? 'hidden' : 'flex'} absolute top-0 left-0 px-5 items-center justify-center  text-gray-500 focus:outline-none focus:bg-gray-800 focus:text-gray-600 z-50 h-16 lg:hidden `} onClick={() => setNavbarOpen(!navbarOpen)}>
        <svg className="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h7">
          </path>
        </svg>
      </button>


      {/* Navbar transparent Background & close Button */}
      {navbarOpen ?
        <div className={` ${navbarOpen === false ? 'hidden' : ''} lg:hidden lg:flex-shrink-0 lg:static inset-0 z-50 fixed bg-black bg-opacity-40`} onClick={() => setNavbarOpen(!navbarOpen)}>

          <div className="flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600 absolute left-[250px] lg:left-80 top-0 z-20   " aria-label="Close sidebar">
            <svg className="h-6 w-6 text-white" stroke="currentColor" fill="none" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12">
              </path>
            </svg>
          </div>
        </div>
        : null}

      {/* Main Navbar */}
      <div className={` ${navbarOpen === false ? 'hidden' : 'flex'} h-screen fixed left-0 inset-y-0 lg:static  lg:left-auto lg:inset-auto lg:flex lg:w-80 w-64 z-50`}>

        <div className="flex bg-[#E5E7EB] flex-col lg:w-72 shadow-md w-64 relative overflow-y-auto">

          <nav className="flex-1  space-y-4 p-4 mt-3">

            <span onClick={() => onClickMenu('/app/hospital/dashboard')} className={`w-full h-12 cursor-pointer space-x-2 flex items-center -mr-5 pl-5 pr-2 py-3 text-md leading-5 font-semibold  focus:outline-none hover:text-pink-600 rounded-full transition ease-in-out duration-150 ${location.pathname === "/app/hospital/dashboard" ? "text-white bg-[#005F60]" : "text-[#005F60]"}`}>
              <span className="rounded-full p-1 bg_icon">
                <DashboardIcon className="w-7 text-white h-7 hover:text-[#005F60]" />
              </span>
              <span className="ml-3">Dashboard</span>
            </span>

            <span onClick={() => onClickMenu('/app/hospital/profile')} className={`w-full  justify-between h-12 cursor-pointer space-x-2 flex items-center -mr-5 pl-5 pr-2 py-3 text-md leading-5 font-semibold  focus:outline-none hover:text-pink-600  rounded-full  transition ease-in-out duration-150 ${location.pathname === "/app/hospital/profile" ? "text-white bg-[#005F60]" : "text-[#005F60]"}`}>

              <div className="flex justify-center items-center">
                <span className="rounded-full p-1 bg_icon">
                  <InsertEmoticonIcon className="w-7 text-white h-7 hover:text-[#005F60]" />
                </span>
                <span className="ml-3">Profile</span>
              </div>
            </span>
            <span onClick={() => onClickMenu('/app/hospital/reviewRating')} className={`w-full h-12 cursor-pointer space-x-2 flex items-center -mr-5 pl-5 pr-2 py-3 text-md leading-5 font-semibold  focus:outline-none hover:text-pink-600  rounded-full  transition ease-in-out duration-150 ${location.pathname === "/app/hospital/reviewRating" ? "text-white bg-[#005F60]" : "text-[#005F60]"}`}>
              <span className="rounded-full p-1 bg_icon">
                <StarBorderPurple500Icon className="w-7 text-white h-7 hover:text-[#005F60]" />
              </span>
              <span className="ml-3">Review Rating</span>
            </span>

            <span onClick={() => onClickMenu('/app/hospital/subscription')} className={`w-full h-12 cursor-pointer space-x-2 flex items-center -mr-5 pl-5 pr-2 py-3 text-md leading-5 font-semibold  focus:outline-none hover:text-pink-600  rounded-full  transition ease-in-out duration-150 ${location.pathname === "/app/hospital/subscription" ? "text-white bg-[#005F60]" : "text-[#005F60]"}`}>
              <span className="rounded-full p-1 bg_icon">
                <SubscriptionsIcon className="w-7 text-white h-7 hover:text-[#005F60]" />
              </span>
              <span className="ml-3">Subscription</span>
            </span>

            <span onClick={() => onClickMenu('/app/hospital/payment')} className={`w-full h-12 cursor-pointer space-x-2 flex items-center -mr-5 pl-5 pr-2 py-3 text-md leading-5 font-semibold  focus:outline-none hover:text-pink-600  rounded-full  transition ease-in-out duration-150 ${location.pathname === "/app/hospital/payment" ? "text-white bg-[#005F60]" : "text-[#005F60]"}`}>
              <span className="rounded-full p-1 bg_icon">
                <PaymentIcon className="w-7 text-white h-7 hover:text-[#005F60]" />
              </span>
              <span className="ml-3">Payment</span>
            </span>


            <ChangePasswordHospitalModel open={open} setOpen={setOpen} />
            <span onClick={() => setOpen(true)} className={`w-full h-12 cursor-pointer space-x-2 flex items-center -mr-5 pl-5 pr-2 py-3 text-md leading-5 font-semibold  focus:outline-none hover:text-pink-600  rounded-full  transition ease-in-out duration-150 ${location.pathname === "/app/hospital/changePassword" ? "text-white bg-[#005F60]" : "text-[#005F60]"}`}>
              <span className="rounded-full p-1 bg_icon">
                <LockIcon className="w-7 text-white h-7 hover:text-[#005F60]" />
              </span>
              <span className="ml-3">Change Password</span>
            </span>

            <span onClick={logoutSubmit} className={`w-full h-12 cursor-pointer flex items-center -mr-5 pl-5 pr-2 py-3 text-md leading-5 font-semibold  focus:outline-none hover:text-pink-600   transition ease-in-out duration-150 ${location.pathname === "/login" ? "text-white bg-[#005F60]" : "text-[#005F60]"}`}>
              <span className="rounded-full p-1 bg_icon ml-1">
              <RiLogoutBoxLine className="w-7 text-white h-7 hover:text-[#005F60]" />
              </span>
              <span className="ml-3 ">Logout</span>
            </span>

          </nav>

        </div>

      </div>
    </>

 
  );

}

function mapStateToProps(state) {
  const { users } = state;
  const { overview } = users ? users : {};
  const { setting, user } = overview ? overview : {};
  return {
    users,
    setting,
    user
  };
}


export default (connect(mapStateToProps)(withRouter(HospitalSidebar)));
